import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import { helloBabyPostPath } from 'lib/urls'

const Topic = (props) => {
  let { topic, lastTopic } = props
  return (
    <li key={topic.slug} style={{ display: 'inline-block' }}>
      <Link
        to={helloBabyPostPath(topic.slug)}
        className="text-uppercase h7 text-bold"
      >
        {topic.name}
      </Link>
      {!lastTopic && <span className="h7 phs">/</span>}
    </li>
  )
}

Topic.propTypes = {
  topic: PropTypes.object,
  lastTopic: PropTypes.bool,
}

export default Topic
